import PropTypes from 'prop-types';

import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import { Fragment } from 'react';

import CollapsibleText from '../CollapsibleText';

import Tag from '../Tag';

import BaseChip from '../BaseChip';

import Link from '../Link';

import styles from './PaymentTimelineCard.module.scss';

const PaymentTimelineCard = ({
  title,
  value = null,
  valueWithoutOffer = null,
  subtitle = null,
  tags = [],
  children = null,
  collapsible = false,
  isCollapsed = true,
  highlighted = false,
  onValueClick = null,
  outlined = true,
  gapSpacing = 'medium'
}) => {
  const ChildrenContainer = collapsible ? CollapsibleText : 'div';

  const childrenContainerProps = collapsible
    ? {
        showMoreText: trans('show.details'),
        showLessText: trans('hide.details'),
        showIcon: false,
        isCollapsed,
        collapseCompletely: true
      }
    : {};

  const cardClasses = classNames(styles['payment-timeline-card'], {
    [styles['payment-timeline-card--highlighted']]: highlighted,
    [styles['payment-timeline-card--outlined']]: outlined
  });

  const hasOffer = Boolean(
    value && valueWithoutOffer && valueWithoutOffer !== value
  );
  const chipsContainerClasses = classNames(
    styles['payment-timeline-card__chips-container'],
    {
      [styles[`payment-timeline-card__chips-container--gap-${gapSpacing}`]]:
        gapSpacing
    }
  );

  const ValueContainer = onValueClick ? Link : 'div';
  const valueContainerProps = onValueClick
    ? {
        onClick: onValueClick
      }
    : {};

  const valueClasses = classNames({
    [styles['payment-timeline-card__value--with-offer']]: hasOffer
  });

  return (
    <div className={cardClasses}>
      <div className={styles['payment-timeline-card__header']}>
        <div
          className={styles['payment-timeline-card__header-title-container']}
        >
          <h4 className={styles['payment-timeline-card__header-title']}>
            {title}
          </h4>
          <div>{subtitle}</div>
        </div>
        {hasOffer && (
          <div
            className={
              styles[
                'payment-timeline-card__header-value-without-offer-container'
              ]
            }
          >
            <span
              className={styles['payment-timeline-card__value--without-offer']}
            >
              {valueWithoutOffer}
            </span>
          </div>
        )}
        {value && (
          <div
            className={styles['payment-timeline-card__header-value-container']}
          >
            <ValueContainer {...valueContainerProps} className={valueClasses}>
              {value}
            </ValueContainer>
          </div>
        )}
      </div>

      {tags.length > 0 && (
        <div className={chipsContainerClasses}>
          {tags.map(tag =>
            typeof tag === 'function' ? (
              <Fragment key={tag.name || tag.toString()}>{tag()}</Fragment>
            ) : (
              <Tag key={tag.label} {...tag} />
            )
          )}
        </div>
      )}

      {children?.length > 0 && (
        <ChildrenContainer {...childrenContainerProps}>
          {children}
        </ChildrenContainer>
      )}
    </div>
  );
};

PaymentTimelineCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  valueWithoutOffer: PropTypes.string,
  subtitle: PropTypes.node,
  tags: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(BaseChip.propTypes), PropTypes.node])
  ),
  children: PropTypes.node,
  collapsible: PropTypes.bool,
  isCollapsed: PropTypes.bool,
  highlighted: PropTypes.bool,
  onValueClick: PropTypes.func,
  outlined: PropTypes.bool,
  gapSpacing: PropTypes.oneOf(['medium', 'big'])
};

export default PaymentTimelineCard;
